import { useRef, useEffect, useState, useContext } from 'react';
import { EditContext } from '@/context/EditContext';
import { projectController } from '@/api';

export default function BilingualSubtitleComponent() {
  const {
    projectDetail, // 项目详情数据
    scaleRatio, // 视频编辑器的缩放比例
    sessionId, // 当前编辑会话ID
    selectedAspectRatio, // 当前选中的视频宽高比
    subtitleBilingualPlayItem, // 字幕播放相关配置
    newcaptionsItem, // 字幕样式配置
    timelinePlaybackTime, // 字幕时间轴配置
    subtitleFontSize, // 当前字幕字号
    translationSubtitleBox, // 字幕容器配置
    translationSubtitleUpdateFlag, // 字幕详情是否需要更新的标志
    UnRedoUpdate, // 撤销重做状态更新
    bilingualismSubtitleBox,
    subtitleShow,
    dimensions,
  } = useContext(EditContext);
  const subtitleRef = useRef(null);

  const [subtitleWidth, setSubtitleWidth] = useState(0);
  const [subtitleHeight, setSubtitleHeight] = useState(0);
  useEffect(() => {
    computedSubtitleWidth();
    // layout比例变化
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAspectRatio]);
  // 监听 newcaptionsItem 变化重新加载字体
  useEffect(() => {
    if (newcaptionsItem?.fontFamilyUrl) {
      const styleSheet = document.createElement('style');
      styleSheet.textContent = `
          @font-face {
            font-family: 'bilingual-custom-font';
            src: url('${newcaptionsItem?.fontFamilyUrl}') format('truetype');
          }
        `;
      document.head.appendChild(styleSheet);
      document.fonts.ready.then(() => {
        computedSubtitleHeight();
      });
      return () => {
        document.head.removeChild(styleSheet);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newcaptionsItem]);
  useEffect(() => {
    computedSubtitleHeight();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    timelinePlaybackTime,
    subtitleBilingualPlayItem,
    UnRedoUpdate,
    newcaptionsItem,
    selectedAspectRatio,
    subtitleFontSize,
    projectDetail?.diySubtitle,
  ]);

  useEffect(() => {
    changeFontLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    subtitleWidth,
    subtitleHeight,
    subtitleFontSize,
    selectedAspectRatio,
    translationSubtitleBox,
    bilingualismSubtitleBox,
    UnRedoUpdate,
    newcaptionsItem,
    subtitleShow,
    dimensions,
  ]);
  // 计算字幕展示位置x和y,每次切换比例要改位置
  const changeFontLocation = () => {
    const subtitle = document.querySelector('#bilingual');
    let x = 0;
    let y = 0;
    let position;
    if (subtitleShow === 3) {
      position = bilingualismSubtitleBox[1];
    } else {
      position = translationSubtitleBox;
    }
    const isPortrait = dimensions.height >= dimensions.width;
    if (selectedAspectRatio === 0) {
      if (!position?.position169?.isTop) {
        x = (1920 - subtitleWidth) / 2;
        y = 1080 - subtitleHeight - position?.position169?.y;
      } else {
        x = position?.position169?.x;
        y = position?.position169?.y;
      }
    }
    if (selectedAspectRatio === 1) {
      if (!position?.position11?.isTop) {
        x = (1080 - subtitleWidth) / 2;
        y = 1080 / 2 - subtitleHeight / 2 - position?.position11?.y;
      } else {
        x = position?.position11?.x;
        y = position?.position11?.y;
      }
    }
    if (selectedAspectRatio === 2) {
      if (!position?.position916?.isTop) {
        x = (1080 - subtitleWidth) / 2;
        y = 1920 / 2 - subtitleHeight / 2 - position?.position916?.y;
      } else {
        x = position?.position916?.x;
        y = position?.position916?.y;
      }
    }
    if (selectedAspectRatio === 3) {
      if (!position?.positionCtm?.isTop) {
        x = (dimensions.width - subtitleWidth) / 2;
        y = isPortrait
          ? dimensions.height / 2 - subtitleHeight / 2 - position?.positionCtm?.y
          : dimensions.height - subtitleHeight - position?.positionCtm?.y;
      } else {
        x = position?.positionCtm?.x;
        y = position?.positionCtm?.y;
      }
    }
    if (subtitle) {
      subtitle.style.transform = `translate(${x}px, ${y}px)`;
    }
  };

  useEffect(() => {
    if (!translationSubtitleUpdateFlag) return;
    changeSubtitleDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [translationSubtitleUpdateFlag]);
  const changeSubtitleDetail = () => {
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    let subtitleBox = { ...translationSubtitleBox };
    if (subtitleShow === 3) {
      subtitleBox = { ...bilingualismSubtitleBox[1] };
    } else {
      subtitleBox = { ...translationSubtitleBox };
    }
    const obj = {
      x: 0,
      y: 0,
    };
    const isPortrait = dimensions.height >= dimensions.width;
    if (selectedAspectRatio === 0) {
      if (!subtitleBox?.position169?.isTop) {
        obj.x = (1920 - subtitleWidth) / 2;
        obj.y = 1080 - subtitleHeight - subtitleBox?.position169?.y;
      } else {
        obj.x = subtitleBox?.position169?.x;
        obj.y = subtitleBox?.position169?.y;
      }
    }
    if (selectedAspectRatio === 1) {
      if (!subtitleBox?.position11?.isTop) {
        obj.x = (1080 - subtitleWidth) / 2;
        obj.y = 1080 / 2 - subtitleHeight / 2 - subtitleBox?.position11?.y;
      } else {
        obj.x = subtitleBox?.position11?.x;
        obj.y = subtitleBox?.position11?.y;
      }
    }
    if (selectedAspectRatio === 2) {
      if (!subtitleBox?.position916?.isTop) {
        obj.x = (1080 - subtitleWidth) / 2;
        obj.y = 1920 / 2 - subtitleHeight / 2 - subtitleBox?.position916?.y;
      } else {
        obj.x = subtitleBox?.position916?.x;
        obj.y = subtitleBox?.position916?.y;
      }
    }
    if (selectedAspectRatio === 3) {
      if (!subtitleBox?.positionCtm?.isTop) {
        obj.x = (dimensions.width - subtitleWidth) / 2;
        obj.y = isPortrait
          ? dimensions.height / 2 - subtitleHeight / 2 - subtitleBox?.positionCtm?.y
          : dimensions.height - subtitleHeight - subtitleBox?.positionCtm?.y;
      } else {
        obj.x = subtitleBox?.positionCtm?.x;
        obj.y = subtitleBox?.positionCtm?.y;
      }
    }
    try {
      projectController.subtitleBox({
        projectId: projectItem.id,
        body: {
          sessionId,
          subtitleBox: obj,
          subtitleType: 1,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  // 计算展示的字幕背景宽度
  const computedSubtitleWidth = () => {
    const isPortrait = dimensions.height >= dimensions.width;
    let w = 0;
    if (selectedAspectRatio === 0) {
      w = 1920 * 0.67;
    }
    if (selectedAspectRatio === 1) {
      w = 1080 * 0.75;
    }
    if (selectedAspectRatio === 2) {
      w = 1080 * 0.75;
    }
    if (selectedAspectRatio === 3) {
      if (isPortrait) {
        w = dimensions.width * 0.75;
      } else {
        w = dimensions.width * 0.67;
      }
    }
    setSubtitleWidth(w);
  };
  // 计算展示的字幕背景高度
  const computedSubtitleHeight = () => {
    let h = 0;
    const bilingualtextItem = document.querySelector('.bilingualtextItem');
    if (bilingualtextItem) {
      h =
        bilingualtextItem.getBoundingClientRect().height / scaleRatio +
        (newcaptionsItem?.paddingtb || 0) * 2;
    }

    setSubtitleHeight(h);
  };

  // 将16进制颜色和透明度转换为rgba格式
  const hexToRgba = (hex, opacity) => {
    if (!hex && hex !== 0) return;
    // 移除��能存在的#号
    hex = hex.replace('#', '');

    // 将hex转为rgb
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // 计算透明度值(0-100转为0-1)
    let alpha = 0;
    if (opacity > 0) {
      alpha = opacity ? opacity / 100 : 1;
    } else {
      alpha = 0;
    }

    // 返回rgba格式
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };
  const formatText = (text) => {
    if (!text) {
      return '';
    }
    // 去掉开头的第一个标点符号
    const processedText = text.replace(/^[\s‘’“”，。、；：！？…—~.,;:'"!?]/, '');
    const lastChar = processedText[processedText.length - 1];
    if (lastChar === '?' || lastChar === '!' || lastChar === '！' || lastChar === '？') {
      return processedText;
    } else {
      const punctuationRegex = /[,.，。、；：'"]/; // 需要删除的标点符号
      if (punctuationRegex.test(lastChar)) {
        return processedText.slice(0, -1);
      }
    }
    return processedText;
  };
  return (
    <>
      <div
        className="target subtitle_style subtitle_box bilingual_subtitle_box"
        id="bilingual"
        style={{
          width: `${subtitleWidth}px`,
          height: `${subtitleHeight}px`,
          opacity: 1,
          zIndex: 3,
          display: `${formatText(subtitleBilingualPlayItem?.text) ? 'block' : 'none'}`,
        }}>
        <div className="subtitle_list" style={{ pointerEvents: 'none' }}>
          <div
            style={{
              fontSize: `${newcaptionsItem?.fontSize || 0}px`,
              background: `${newcaptionsItem?.showBgColor && formatText(subtitleBilingualPlayItem?.text) ? hexToRgba(newcaptionsItem?.rectBgColor, newcaptionsItem?.rectBgOpacity) : 'none'}`,
              padding: `${newcaptionsItem?.paddingtb || 0}px ${newcaptionsItem?.paddinglr || 0}px`,
              color: `${hexToRgba(newcaptionsItem?.fontColor, newcaptionsItem?.fontOpacity)}`,
              borderRadius: `${newcaptionsItem?.rectRadius}px`,
              fontStyle: newcaptionsItem?.fontItalic ? 'italic' : 'normal',
              fontWeight: newcaptionsItem?.fontBold ? 'bold' : 'normal',
            }}>
            <div className="text">
              <div
                className="text_span"
                style={{
                  WebkitTextStroke: `${newcaptionsItem?.outlineSize && newcaptionsItem?.showOutline ? `${newcaptionsItem?.outlineSize}px ${hexToRgba(newcaptionsItem?.outlineColor, newcaptionsItem?.outlineOpacity)}` : 0}`,
                }}>
                {formatText(subtitleBilingualPlayItem?.text)}
              </div>
              {newcaptionsItem?.showShadow && (
                <div
                  className="text_span"
                  style={{
                    position: 'absolute',
                    top: `${newcaptionsItem?.shadowY}px`,
                    left: `${newcaptionsItem?.shadowX}px`,
                    width: '100%',
                    height: '100%',
                    filter: `blur(${newcaptionsItem?.shadowBlur}px)`,
                    zIndex: 1,
                    pointerEvents: 'none',
                    color: `${hexToRgba(newcaptionsItem?.shadowColor, newcaptionsItem?.shadowOpacity)}`,
                  }}>
                  {formatText(subtitleBilingualPlayItem?.text)}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="subtitle_style subtitle_box_none bilingual_subtitle_box_none"
        style={{
          padding: `${newcaptionsItem?.paddingtb}px ${newcaptionsItem?.paddinglr}px`,
          fontSize: `${newcaptionsItem?.fontSize || 0}px`,
          fontStyle: newcaptionsItem?.fontItalic ? 'italic' : 'normal',
          fontWeight: newcaptionsItem?.fontBold ? 'bold' : 'normal',
          WebkitTextStroke: `${newcaptionsItem?.outlineSize ? `${newcaptionsItem?.outlineSize}px ${newcaptionsItem?.outlineColor}` : 0}`,
        }}>
        <div ref={subtitleRef} className="text bilingualtextItem">
          {formatText(subtitleBilingualPlayItem?.text)}
        </div>
      </div>
    </>
  );
}
